<template>
  <div class="p-ke pb-3 " id="p-ke">
    <div class="h11 position-relative" id="p-ke-1"></div>
    <!--<div class="shade">-->
    <!--<img class="w-100" src="assets/img/pro/ke-shade.png">-->
    <!--</div>-->
    <div class="b-title pt-28 pb-3 ke-title text-white d-flex align-items-center border-bottom-aac7ff">
      项目课程
    </div>
    <div class="p-body px-3 mt-20" v-if="curCourseList && curCourseList.length>0">
      <div v-for="(item, index) in curCourseList" :key="index">
        <div v-if="item.course && item.course.title" class="course-title  d-flex align-items-center">
          <img class="mr-12" src="/static/img/pro/quan1.png"/>
          <span class="color-f0" v-if="item.mustSelected">【必学】</span>
          <p class="mb-0 van-multi-ellipsis--l2 text-white text-justify">{{item.course.title}}</p>
        </div>

      </div>
    </div>
    <div v-else>
      <no-data class="noData-white" text="项目课程正在配置中"></no-data>
    </div>
    <div @click="getCourseList" v-if="isShow && !isClose"
         class="cursor-pointer w-100 d-flex justify-content-center align-items-center text-white font-12">
      <img class="mr-12 w-14p" src="/static/img/pro/down-more.png"/>展开
    </div>
    <div @click="goStart" v-if="isShow && isClose"
         class="cursor-pointer w-100 d-flex justify-content-center align-items-center text-white font-12">
      <img class="mr-12 w-14p" src="/static/img/pro/shou1.png"/>
      收起
    </div>
  </div>
</template>

<script>
  import NoData from '@/components/noData';

  export default {
    name: "advCourse",
    components: {
      NoData,
    },
    data() {
      return {
        courseList: [],
        curCourseList: [],
        isShow: false,
        isClose: false,
        page: 0,
        advSubCourse: {}
      }
    },
    created() {
      this.advSubCourse = this.advSub;
      this.getCList();
    },
    props: [
      'advSub'
    ],
    // watch: {
    //   advSub: function (newVal, oldVal) {
    //     console.log(newVal)
    //     if (newVal.courseList && newVal.courseList.length > 0) {
    //       this.courseList = newVal.courseList;
    //       if (this.courseList && this.courseList.length > 10) {
    //         this.isShow = true;
    //       } else {
    //         this.isShow = false;
    //       }
    //       console.log(this.courseList)
    //       this.curCourseList = this.courseList.slice(0, 10);
    //     }
    //   },
    // },
    methods: {
      getCList() {
        if (this.advSubCourse.courseList && this.advSubCourse.courseList.length > 0) {
          this.courseList = this.advSubCourse.courseList;
          if (this.courseList && this.courseList.length > 10) {
            this.isShow = true;
          } else {
            this.isShow = false;
          }
          console.log(this.courseList)
          this.curCourseList = this.courseList.slice(0, 10);
        }
      },
      getCourseList() {
        this.page += 1;
        let arr = this.courseList.slice(this.page * 10, this.page * 10 + 10);
        if (arr.length === 10) {
          this.isClose = false;
        } else {
          this.isClose = true;
        }
        this.curCourseList = this.curCourseList.concat(arr);
      },
      goStart() {
        this.isClose = false;
        this.page = 0;
        this.curCourseList = this.courseList.slice(0, 10);
      }
    }
  }
</script>

<style>

</style>
